import React from 'react';
import { Grid } from '@mui/material';
import BoxScoreTeamRow from './BoxScoreTeamRow';
import BoxScoreSplitStats from './BoxScoreSplitStats';
import BoxScoreHeader from './BoxScoreHeader';

interface ITeamProps {
  teamName: string;
  teamRecord: string;
  teamScore: number;
  teamLink: string;
  teamLogoUrl?: string;
  teamWin: boolean;
  firstHalfScore?: number;
  secondHalfScore?: number;
  overtime1Score?: number;
  overtime2Score?: number;
  overtime3Score?: number;
  overtime4Score?: number;
  overtime5Score?: number;
  overtime6Score?: number;
  overtimeScore?: number;
  quarter1Score?: number;
  quarter2Score?: number;
  quarter3Score?: number;
  quarter4Score?: number;
  rank?: number;
  rankType?: string;
};

interface IProps {
  data: {
    date: string;
    venue: string;
    numberOfOvertimes: number;
    home: ITeamProps;
    visitor: ITeamProps;
    tournamentName?: string;
    tournamentRound?: string;
  };
};

function BoxScore({ data }: IProps) {  
  return (
    <>
      <BoxScoreHeader date={data.date} venue={data.venue} tournamentName={data.tournamentName} tournamentRound={data.tournamentRound} />
      <Grid container direction='row' paddingY={3}>
        <Grid item xs={5}>
          <Grid container direction='column'>
            <Grid item>
              <BoxScoreTeamRow
                key='visitor-team-tow'
                teamName={data.visitor.teamName}
                teamRecord={data.visitor.teamRecord}
                teamScore={data.visitor.teamScore}
                teamLink={data.visitor.teamLink}
                teamLogoUrl={data.visitor.teamLogoUrl}
                teamWin={data.visitor.teamWin}
                rank={data.visitor.rank}
                rankType={data.visitor.rankType}
              />
            </Grid>
            <Grid item>
              <BoxScoreTeamRow
                key='home-team-tow'
                teamName={data.home.teamName}
                teamRecord={data.home.teamRecord}
                teamScore={data.home.teamScore}
                teamLink={data.home.teamLink}
                teamLogoUrl={data.home.teamLogoUrl}
                teamWin={data.home.teamWin}
                rank={data.home.rank}
                rankType={data.home.rankType}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={7}>
          { /* Using non-strict equality to check for both null and undefined.  Want to be explicit here since 0 is a valid value. */
           (data.home.firstHalfScore != null || data.home.quarter1Score != null) &&
            <BoxScoreSplitStats 
              home={data.home}
              homeTeamLogoUrl={data.home.teamLogoUrl}
              visitor={data.visitor}
              visitorTeamLogoUrl={data.visitor.teamLogoUrl}
              numberOfOvertimes={data.numberOfOvertimes}
            /> 
          }
        </Grid>
      </Grid>
    </>
  );
}

export default BoxScore;
